export default {
  de: {
    inProgress: 'Der Swing-Index-Bereich wird aktuell gewartet.',
  },
};
